export const adDecisionToPauseOverlay = (adData) =>
  adData.message === 'no ads'
    ? {}
    : {
        title: adData.custom?.heading ?? adData.title,
        description: adData.custom?.longDescription ?? adData.description,
        image: adData.images?.find((image) => image.height === 128),
        action: adData.clickUrl && {
          handler: 'openUrl',
          url: adData.clickUrl,
        },
        beacons: adData.beacons,
      }
